import { HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class CatalogService {

    constructor(private http: HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';
        req.trash = req.trash || '';

        req.skipGroups = req.skipGroups || '';

        let requestUrl = environment.apiUrl + 'catalog/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter + "&trash=" + req.trash + '&skipGroups=' + req.skipGroups;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    add(catalog){
        let requestUrl = environment.apiUrl + 'catalog/store';
        return this.http.post(requestUrl, catalog).map( (res: any) => {
            return res;
        });
    }

    edit(catalog){
        let requestUrl = environment.apiUrl + 'catalog/update/' + catalog.id;
        return this.http.put(requestUrl, catalog).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'catalog/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    getGroupedStudies(id){
        let requestUrl = environment.apiUrl + 'catalog/getGroupedStudies/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    restore(id){
        let requestUrl = environment.apiUrl + 'catalog/restore/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id, forceDelete){
        let requestUrl = environment.apiUrl + 'catalog/delete/' + id;
        if(forceDelete){
            requestUrl += '?forceDelete=1';
        }
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/catalog.service.ts